import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { setLanguagePreference } from "../../i18n";

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const french = i18n.resolvedLanguage === "fr";
  useEffect(() => {
    if (!open) return;
    const close = (event: MouseEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  return (
    <div className="language-selector" ref={root}>
      <button
        type="button"
        className="language-trigger"
        aria-label={t("Language")}
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen((value) => !value)}
      >
        <span aria-hidden="true">{french ? "🇫🇷" : "🇬🇧"}</span>
      </button>
      {open && (
        <div className="language-menu" role="menu">
          <button
            type="button"
            role="menuitem"
            aria-label="English"
            className={!french ? "active" : ""}
            onClick={() => {
              setLanguagePreference("en");
              setOpen(false);
            }}
          >
            <span aria-hidden="true">🇬🇧</span>
            English
          </button>
          <button
            type="button"
            role="menuitem"
            aria-label="Français"
            className={french ? "active" : ""}
            onClick={() => {
              setLanguagePreference("fr");
              setOpen(false);
            }}
          >
            <span aria-hidden="true">🇫🇷</span>
            Français
          </button>
        </div>
      )}
    </div>
  );
}
